module.exports = __webpack_public_path__ + "7ed10d428f813205b50b2ec416f416e0.pdf";